// The video editor's text strings (components/Editor), under t('editor.rve.text.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  transcript: {
    heading: 'Transcrição',
    wordsOne: '{n} palavra',
    wordsMany: '{n} palavras',
    seconds: '{n} s',
    minutes: '{m} min {s} s',
    editWord: 'Editar palavra',
    noPauses: 'Este clipe não tem pausas longas.',
    cutSpeaker: 'Cortar tudo o que {name} diz ({n} palavras)',
    speakerMenu: '{name}: o que diz',
    cantListen: 'Não foi possível ouvir o som deste clipe. Tente de novo daqui a pouco.',
    emptyTitle: 'Nenhuma transcrição para editar',
    emptyBody: 'A transcrição vem das legendas deste vídeo. Adicione legendas e as palavras aparecem aqui: corte uma palavra e ela sai do vídeo.',
    removeFillersTitle: 'Corta cada "é…", "hã" e "hmm"',
    removeFillers: 'Tirar hesitações ({n})',
    removePausesTitleClip: 'Ouve o clipe e encurta cada silêncio maior que 0.6 s',
    removePausesTitle: 'Encurta cada silêncio maior que 0.7 s',
    listening: 'Procurando as pausas…',
    removePauses: 'Tirar pausas',
    removePausesCount: 'Tirar pausas ({n} · {duration})',
    emphasizeTitle: 'As palavras-chave ficam na cor de destaque das legendas',
    unmark: 'Desmarcar',
    emphasize: 'Destacar',
    cut: 'Cortar',
    clearSelection: 'Limpar seleção',
    hintTitle: 'Clique numa palavra para ir até ela · Shift+clique ou arraste para selecionar · Delete corta a seleção · clique duas vezes numa palavra para corrigir',
    hint: "Clique para ir · {key} corta · clique duplo corrige",
    deleteKey: "Delete",
    nothingToRemove: "Não há vícios de linguagem nem pausas longas para tirar.",
    hintTouch: "Toque numa palavra para selecionar · corte ou corrija pela barra",
    fixWord: "Corrigir",
  },

  transcribe: {
    uploadedVideo: 'Vídeo enviado',
    jobTitle: 'Legendas · {name}',
    video: 'vídeo',
    transcribe: 'Transcrever',
    carriesOn: '{step}… continua mesmo se você trocar de painel.',
    dismiss: 'Fechar',
    usesMinutes: 'Usa os minutos do seu plano, como as Legendas automáticas. As legendas vão para a linha do tempo, embaixo do vídeo.',
  },

  captions: {
    srtFailed: 'Não foi possível ler o SRT: {n} erro(s)',
    noCaptionsInSrt: 'Nenhuma legenda encontrada no arquivo SRT.',
    invalidJson: 'Formato JSON inválido. O esperado é { words: [...] }',
    jsonFailed: 'Não foi possível ler o arquivo JSON. Confira o formato.',
    textFailed: 'Não foi possível ler o arquivo de texto.',
    unsupported: 'Formato não suportado. Use .srt, .json ou .txt',
    line: 'Linha {n}',
    moreErrors: '...e mais {n} erros',
    dismiss: 'Fechar',
    processing: 'Processando...',
    upload: 'Enviar arquivo de legendas',
    supported: 'Aceitos: .srt, .json, .txt',
    srtHelp: 'Arquivos SRT trazem o tempo exato de cada legenda. Dá para exportar SRT na maioria das ferramentas de transcrição.',
    or: 'ou',
    scriptPlaceholder: 'Digite ou cole seu roteiro aqui...',
    generate: 'Gerar legendas',
    clear: 'Limpar',
    label: 'Legendas',
    seekTo: 'Ir para {time}',
    start: 'Início',
    end: 'Fim',
    textPlaceholder: 'Digite o texto da legenda...',
  },

  srt: {
    empty: 'O arquivo está vazio',
    tooShort: 'Arquivo curto demais: precisa ter pelo menos uma legenda',
    noTimestamps: 'Nenhum tempo SRT válido. Formato esperado: HH:MM:SS,mmm --> HH:MM:SS,mmm',
    badNumber: 'Número de legenda inválido: "{value}"',
    noTiming: 'Falta a linha de tempo',
    badTiming: 'Formato de tempo inválido: "{value}"',
    badTime: 'Tempo inválido na legenda {n}',
    startAfterEnd: 'O início precisa vir antes do fim na legenda {n}',
    noText: 'A legenda {n} não tem texto',
    emptyText: 'O texto da legenda {n} está vazio',
    blockFailed: 'Não foi possível ler o bloco de legenda {n}',
    overlap: 'As legendas {a} e {b} se sobrepõem no tempo',
  },

  srtErrors: {
    title: 'Não foi possível ler o arquivo SRT',
    file: 'Arquivo:',
    foundOne: 'Encontramos {n} erro no arquivo SRT.',
    foundMany: 'Encontramos {n} erros no arquivo SRT.',
    fixAndRetry: 'Corrija e tente de novo.',
    someSkipped: 'Algumas legendas podem ter ficado de fora.',
    validation: 'Erro de validação',
    format: 'Erro de formato',
    timing: 'Erro de tempo',
    encoding: 'Erro de codificação',
    error: 'Erro',
    solutionsTitle: 'Soluções comuns:',
    solutions: [
      'Confira se o seu arquivo SRT segue o formato padrão',
      'Confira se os tempos usam o formato HH:MM:SS,mmm → HH:MM:SS,mmm',
      'Verifique se os números das legendas estão em sequência',
      'Separe cada bloco de legenda com uma linha em branco',
      'Confira se cada início vem antes do seu fim',
    ],
    expectedFormat: 'Formato SRT esperado:',
    tryAnother: 'Tentar outro arquivo',
  },

  captionStyle: {
    templates: {
      minimal: 'Minimal',
      neon: 'Neon',
      tiktok: 'TikTok',
      comic: 'Quadrinhos',
      elegant: 'Elegante',
      glitch: 'Glitch',
      bold: 'Forte',
      clean: 'Limpo',
      outline: 'Contorno',
    },
    cases: {
      normal: 'Normal',
      uppercase: 'MAIÚSCULAS',
      lowercase: 'minúsculas',
      capitalize: 'Iniciais Maiúsculas',
    },
    animations: {
      fade: 'Esmaecer',
      tiktok: 'TikTok',
      slide: 'Deslizar',
      pop: 'Pop',
      glitch: 'Glitch',
    },
    text: 'Texto',
    highlight: 'Destaque',
    stroke: 'Contorno',
    customize: 'Personalizar',
    position: 'Posição',
    fontAndText: 'Fonte e texto',
    fontPlaceholder: 'Fonte...',
    size: 'Tamanho',
    casePlaceholder: 'Maiúsculas...',
    outline: 'Contorno',
    shadow: 'Sombra',
    background: 'Fundo',
    showBackground: 'Mostrar fundo',
    color: 'Cor',
    opacity: 'Opacidade',
    animationAndTiming: 'Animação e ritmo',
    animationPlaceholder: 'Animação...',
    speed: 'Velocidade',
    highlightScale: 'Escala do destaque ({n}%)',
    words: 'Palavras',
    spacing: 'Espaçamento',
    lineHeight: 'Altura da linha',
    letterSpacing: 'Espaço entre letras',
    normalSpacing: 'normal',
    transforms: 'Transformar',
    rotation: 'Rotação',
    skew: 'Inclinação',
    scale: 'Escala',
  },

  textPanel: {
    elements: 'Elementos',
    hookTitle: 'Título gancho',
    hookDefault: 'Espera só…',
    hookOver: '"{text}" nos primeiros 3 segundos',
    templates: {
      modern: { name: 'Título moderno', preview: 'Elegante e minimalista' },
      impact: { name: 'Frase de impacto', preview: 'Forte e imponente' },
      slicedText: { name: 'Texto fatiado', preview: 'Ousado e moderno' },
      minimalMonochrome: { name: 'Monocromático minimal', preview: 'Ultraminimalista' },
      highlight: { name: 'Caixa de destaque', preview: 'Moderno e marcante' },
      gradient: { name: 'Degradê pop', preview: 'Dinâmico e moderno' },
      neonFuture: { name: 'Neon futurista', preview: 'Elétrico e forte' },
      avantGarde: { name: 'Vanguarda', preview: 'Na moda' },
      glassmorphic: { name: 'Efeito vidro', preview: 'Transparência moderna' },
    },
  },

  textDetails: {
    preview: 'Prévia do texto',
    placeholder: 'Digite seu texto aqui...',
    settings: 'Ajustes',
    style: 'Estilo',
    typography: 'Tipografia',
    fontFamily: 'Fonte',
    selectFont: 'Escolha uma fonte',
    fonts: {
      sans: 'Inter (Sem serifa)',
      serif: 'Merriweather (Serifada)',
      mono: 'Roboto Mono (Monoespaçada)',
    },
    alignment: 'Alinhamento',
    alignLeft: 'Alinhar à esquerda',
    alignCenter: 'Centralizar',
    alignRight: 'Alinhar à direita',
    colors: 'Cores',
    textColor: 'Cor do texto',
    highlight: 'Destaque',
    gradientNoColors: 'As cores não podem ser alteradas em estilos de texto com degradê',
  },
};
